import React from 'react'
import AnsUser from '../ansuser/AnsUser'
import MenuAdmin from './navAdmin/Menu'

function CommentAdmin() {
    return (
        <div className='global-page'>
            <MenuAdmin menuActive={'ans'} />
            <AnsUser roleUser={'Admin'}/>
        </div>
    )
}

export default CommentAdmin